
import {
  flattenDashboardShortcutGroups,
  getAvailableDashboardShortcutGroups,
  getDashboardShortcutLocation,
  getSelectedDashboardShortcutIds,
} from "../dashboardShortcuts";

export default {
  data() {
    return {
      menuOpen: false,
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser || {};
    },
    availableShortcuts() {
      return flattenDashboardShortcutGroups(
        getAvailableDashboardShortcutGroups(this.currentUser?.recursos || [])
      );
    },
    selectedShortcuts() {
      const selectedIds = getSelectedDashboardShortcutIds(
        this.currentUser?.dashboard_shortcuts,
        this.availableShortcuts
      );
      const shortcutsById = new Map(
        this.availableShortcuts.map((shortcut) => [shortcut.id, shortcut])
      );

      return selectedIds.map((id) => shortcutsById.get(id)).filter(Boolean);
    },
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    navigateToShortcut(shortcutId) {
      this.menuOpen = false;
      this.$router.push(getDashboardShortcutLocation(shortcutId));
    },
  },
};
